import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getApprovedTrades,
  getCenterMemberships,
} from "../../../store/actions/centerActions/studentAction";

export default function Dashboard() {
  const { center } = useSelector((state) => state);
  const { centerAuth } = center;
  const { profile } = centerAuth;
  const dispatch = useDispatch();

  // The trades (courses) + per-trade seats the council approved for this
  // centre. Admission is allowed only in these; the rest show "Not Approved".
  const [approvedTrades, setApprovedTrades] = useState(null);
  // Membership applications from this centre's own students.
  const [memberships, setMemberships] = useState(null);
  useEffect(() => {
    dispatch(getApprovedTrades()).then((rows) =>
      setApprovedTrades(Array.isArray(rows) ? rows : [])
    );
    dispatch(getCenterMemberships()).then((rows) =>
      setMemberships(Array.isArray(rows) ? rows : [])
    );
  }, []);

  const statusColor = (s) =>
    s === "Approved" ? "green" : s === "Rejected" ? "#c0392b" : "#b8860b";

  return (
    <div class="mid-content-box">
      <div class="box-welcome">
        <div class="row">
          <div class="col-md-6">
            <div class="box-status">
              <div class="box-statusImg">
                <img src="/images/girl.png" />
              </div>
              <div class="box-statusData">
                <h2>
                  Hello <span>{profile.center_name}</span>
                </h2>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <ul class="selectDrops">
              <li>
                <Link to="/center/add-student" class="addNewchild">
                  Add Student
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="grid-box">
        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor1">
              <div class="img-data">
                <img src="/images/student.png" />
              </div>
              <div class="grid-content">
                <h5>Total Seats</h5>
                <h6>{profile.total_seats}</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor2">
              <div class="img-data">
                <img src="/images/student.png" />
              </div>
              <div class="grid-content">
                <h5>Remaining Seats</h5>
                <h6>
                  {Math.max(
                    0,
                    (profile.total_seats || 0) - (profile.student_count || 0)
                  )}
                </h6>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor3">
              <div class="img-data">
                <img src="/images/student.png" />
              </div>
              <div class="grid-content">
                <h5>Total Student</h5>
                <h6>{profile.student_count}</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor4">
              <div class="img-data">
                {" "}
                <img src="/images/teacher.png" />
              </div>
              <div class="grid-content">
                <h5>Total Staff</h5>
                <h6>{profile.staff?.length}</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor5">
              <div class="img-data">
                {" "}
                <img src="/images/wallet.png" />
              </div>
              <div class="grid-content">
                <h5>My Certificates</h5>
                {/* certificates actually taken by this center */}
                <h6>{profile.certificate_count || 0}</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="grid-data gcolor5">
              <div class="img-data">
                {" "}
                <img src="/images/student.png" />
              </div>
              <div class="grid-content">
                <h5>Certified Students</h5>
                {/* students whose result is out, so a certificate can be taken */}
                <h6>{profile.certified_count || 0}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Courses (trades) the council approved for this centre, with the seats
          allotted per course. Admission is allowed only in these. */}
      <div class="grid-box" style={{ marginTop: "18px" }}>
        <div
          style={{
            background: "#fff",
            border: "1px solid #e3e6ef",
            borderRadius: "8px",
            padding: "16px 18px",
          }}
        >
          <h5 style={{ marginBottom: "12px", fontWeight: "bold" }}>
            Approved Courses &amp; Seats
          </h5>
          {approvedTrades === null ? (
            <p style={{ margin: 0, color: "#888" }}>Loading...</p>
          ) : approvedTrades.length === 0 ? (
            <p style={{ margin: 0, color: "#c0392b" }}>
              No courses approved yet. Please contact the council. Admission can
              be taken only in approved courses.
            </p>
          ) : (
            <div class="table-responsive">
              <table class="table" style={{ marginBottom: 0 }}>
                <thead class="thead-info">
                  <tr>
                    <th scope="col">Sr.No</th>
                    <th scope="col">Course (Trade)</th>
                    <th scope="col">Seats Allotted</th>
                  </tr>
                </thead>
                <tbody>
                  {approvedTrades.map((t, index) => (
                    <tr key={t.id}>
                      <td>{index + 1}</td>
                      <td>{t.name}</td>
                      <td>{t.seats}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Membership applications from this centre's students, with status +
          reject reason. Shown only when there are any. */}
      <div class="grid-box" style={{ marginTop: "18px" }}>
        <div
          style={{
            background: "#fff",
            border: "1px solid #e3e6ef",
            borderRadius: "8px",
            padding: "16px 18px",
          }}
        >
          <h5 style={{ marginBottom: "12px", fontWeight: "bold" }}>
            Student Membership Applications
          </h5>
          {memberships === null ? (
            <p style={{ margin: 0, color: "#888" }}>Loading...</p>
          ) : memberships.length === 0 ? (
            <p style={{ margin: 0, color: "#888" }}>
              No membership applications from your students yet.
            </p>
          ) : (
            <div class="table-responsive">
              <table class="table" style={{ marginBottom: 0 }}>
                <thead class="thead-info">
                  <tr>
                    <th scope="col">Sr.No</th>
                    <th scope="col">Student</th>
                    <th scope="col">Roll No</th>
                    <th scope="col">Course</th>
                    <th scope="col">Reg. No</th>
                    <th scope="col">Plan</th>
                    <th scope="col">Payment</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {memberships.map((m, index) => (
                    <tr key={m.id}>
                      <td>{index + 1}</td>
                      <td>{m.student_name}</td>
                      <td>{m.roll_number}</td>
                      <td>{m.course}</td>
                      <td>{m.registration_number}</td>
                      <td>{m.membership_plan}</td>
                      <td
                        style={{
                          color: m.payment_status === "Paid" ? "green" : "#b8860b",
                          fontWeight: "bold",
                        }}
                      >
                        {m.payment_status}
                      </td>
                      <td>
                        <span
                          style={{
                            color: statusColor(m.status),
                            fontWeight: "bold",
                          }}
                        >
                          {m.status}
                        </span>
                        {m.status === "Rejected" && m.reject_reason ? (
                          <div style={{ color: "#c0392b", fontSize: "12px" }}>
                            {m.reject_reason}
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <div class="Title-box">
        <div class="row">
          <div class="col-md-6">
            <Link to="/center/edit" class="btn btn-comman">
              My Profile Edit
            </Link>
          </div>
        </div>
      </div>
      {/* <div class="Widthdata">
        <div class="Applicationdata">
          <div class="cartitems">
            <div class="cartitembox">
              {" "}
              <div class="PaymentStatus">
                <a
                  href="/colleges/N-K-Paramedical---Medical-Research-Center-Meerut-U-P-/7"
                  target="_blank"
                  class="btn btn-makepay"
                >
                  {" "}
                  View
                </a>
              </div>
              <div class="cartTop row">
                <div class="cartThumb col-md-5">
                  <div class="cartImg">
                    <img height={"100%"} src={profile.md_pic} />
                  </div>
                </div>
                <div class="cartCentent col-md-7">
                  <div class="quick-names">
                    <div class="QVasName">{profile.center_name}</div>
                    <div class="QLocationmark">
                      {`${profile.center_address}  ${profile.center_city} ${profile.center_state}`}
                    </div>
                  </div>

                  <div class="cartAdate">
                    <div class="col-Dates">
                      <h5>Md Name</h5>
                      <h6>{profile.md_name}</h6>
                    </div>

                    <div class="col-Dates">
                      <h5>Contact Number</h5>
                      <h6>{profile.mobile}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
